var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.businessFrontTags && _vm.businessFrontTags.length > 0)?[_c('CapsuleTabs',{attrs:{"value":_vm.businessFrontTagId,"tabList":_vm._f("formatBusiness")(_vm.businessFrontTags)},on:{"handChangeCapsule":_vm.handChangeCapsule}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }